import React from 'react';

import startsWith from 'lodash/startsWith';
import {convertNodeToElement} from 'react-html-parser';

import {VIDEO_DETAILS} from 'app/urls';

import {VideoDisplay} from './VideoDisplay';

import {hasHref, isInsidePre} from '../node-processors-utils';

import type {ProcessorType} from '../node-processors-types';

export const SweetVideoEmbedProcessor: ProcessorType = {
  tag: 'a',
  condition: (node) => hasHref(node) && !isInsidePre(node),
  processor: (node, index, transform) => {
    const parser = document.createElement('a');
    parser.href = node.attribs.href;

    let pathname: string;

    try {
      pathname = parser.pathname;
    } catch {
      return [null, convertNodeToElement(node, index, transform)];
    }

    if (startsWith(pathname, document.location.host)) {
      pathname = pathname.replace(document.location.host, '');
    }

    if (startsWith(pathname, document.location.origin)) {
      pathname = pathname.replace(document.location.origin, '');
    }

    if (pathname[0] !== '/') {
      pathname = '/' + pathname;
    }

    if (startsWith(pathname, VIDEO_DETAILS)) {
      // fetch hashid from /video/hashid.ext
      const match = node.attribs.href.match(/(\w+)\.(\w+)(#.*)?$/);

      if (match != null) {
        return [null, <VideoDisplay key={index} hashid={match[1]} />];
      }
    }

    return [node, null];
  },
};
